var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackAuthscreenMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 24,
    height: 24,
    transform: "translate(1387 1801)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2682",
    "data-name": "Group 2682",
    transform: "translate(-32 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-1355 -1641)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left-arrow",
    d: "M23.167,13.5H6.542l6.366-6.063a.833.833,0,0,0-1.15-1.207l-7.27,6.925A1.666,1.666,0,0,0,4.5,15.526l7.256,6.911a.833.833,0,1,0,1.15-1.207L6.516,15.167H23.167a.833.833,0,0,0,0-1.667Z",
    transform: "translate(1385 1798.667)",
    fill: "#a9a9a9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackAuthscreenMobileIcon);
export default __webpack_public_path__ + "static/media/back-authscreen-mobile-icon.e948f6c3f68683e5a83e79a6ab5dfe69.svg";
export { ForwardRef as ReactComponent };